
export const currencyFilter = ({ value, decimals = 0, prefix = '', suffix = '', conditionalDecimals = false }: CurrencyFilterProps): string => {
 // Filtro usado para visualizar información de moneda. Para elementos input, debe usarse currencyMask del archivo masks.js
 if (!value) return '';

 const decFixed: string = (value / 1).toFixed(decimals);
 const val: string = (conditionalDecimals && decFixed.split('.')[1] === '00') ? decFixed.split('.')[0] : decFixed.replace('.', '.');

 return `${prefix}${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${suffix}`;
};


interface CurrencyFilterProps {
 value: number | null | undefined;
 decimals?: number;
 prefix?: string;
 suffix?: string;
 conditionalDecimals?: boolean;
}
